import * as React from "react";
const SvgFiRrDryerAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v14c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3zM6.5 6a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 6M9 4.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 9 4.5M12 8c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m-1.629 7.73c.037.196.157.365.292.501.285.286.327.736.16 1.104-.281.619-1.102.788-1.58.306-.365-.368-.711-.875-.837-1.538-.167-.881.283-1.796.718-2.585.492-.892.517-1.169.505-1.247-.037-.196-.157-.365-.292-.501-.285-.286-.327-.736-.16-1.104.281-.619 1.102-.788 1.58-.306.365.368.711.875.837 1.538.167.881-.283 1.796-.718 2.585-.492.892-.517 1.169-.505 1.247m4 0c.037.196.157.365.292.501.285.286.327.736.16 1.104-.281.619-1.102.788-1.58.306-.365-.368-.711-.875-.837-1.538-.167-.881.283-1.796.718-2.585.492-.892.517-1.169.505-1.247-.037-.196-.157-.365-.292-.501-.285-.286-.327-.736-.16-1.104.281-.619 1.102-.788 1.58-.306.365.368.711.875.837 1.538.167.881-.283 1.796-.718 2.585-.492.892-.517 1.169-.505 1.247"
    />
  </svg>
);
export default SvgFiRrDryerAlt;
